export default __webpack_public_path__ + "static/media/insert.f872080a.jpg";